import type {ListMaterialFunctionsSearchInput} from "./list-material-functions.schema";

import {listMaterialFunctions} from "@project/sdk/engineering";
import {ListMaterialFunctionsResponse} from "@project/sdk/engineering/zod";
import {queryOptions} from "@tanstack/react-query";

import {queryPolicyDefaults} from "../../../../../shared/query/query-policies";
import {materialFunctionKeys} from "../../../materialFunction-keys";

import {listMaterialFunctionsSearchSchema} from "./list-material-functions.schema";

export function listMaterialFunctionsQueryOptions(rawInput: ListMaterialFunctionsSearchInput) {
  const params = listMaterialFunctionsSearchSchema.parse(rawInput);

  return queryOptions({
    ...queryPolicyDefaults.warm,
    staleTime: 0,
    queryKey: materialFunctionKeys.list(params),
    queryFn: async ({signal}) =>
      ListMaterialFunctionsResponse.parse(await listMaterialFunctions(params, {signal})),
  });
}
